/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalCommonCustomAttributeDoubleSelectTypeValueFromJSON, InternalCommonCustomAttributeDoubleSelectTypeValueToJSON, } from './InternalCommonCustomAttributeDoubleSelectTypeValue';
import { InternalCommonSharingVisibilityFromJSON, InternalCommonSharingVisibilityToJSON, } from './InternalCommonSharingVisibility';
/**
 * @export
 */
export const InternalCommonCustomAttributeDoubleSelectTypeTypeEnum = {
    DoubleSelect: 'double_select'
};
/**
 * Check if a given object implements the InternalCommonCustomAttributeDoubleSelectType interface.
 */
export function instanceOfInternalCommonCustomAttributeDoubleSelectType(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('visibility' in value) || value['visibility'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('value' in value) || value['value'] === undefined)
        return false;
    return true;
}
export function InternalCommonCustomAttributeDoubleSelectTypeFromJSON(json) {
    return InternalCommonCustomAttributeDoubleSelectTypeFromJSONTyped(json, false);
}
export function InternalCommonCustomAttributeDoubleSelectTypeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'visibility': InternalCommonSharingVisibilityFromJSON(json['visibility']),
        'type': json['type'],
        'value': InternalCommonCustomAttributeDoubleSelectTypeValueFromJSON(json['value']),
        'options': json['options'] == null ? undefined : json['options'],
    };
}
export function InternalCommonCustomAttributeDoubleSelectTypeToJSON(json) {
    return InternalCommonCustomAttributeDoubleSelectTypeToJSONTyped(json, false);
}
export function InternalCommonCustomAttributeDoubleSelectTypeToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'visibility': InternalCommonSharingVisibilityToJSON(value['visibility']),
        'type': value['type'],
        'value': InternalCommonCustomAttributeDoubleSelectTypeValueToJSON(value['value']),
        'options': value['options'],
    };
}
